import { render, staticRenderFns } from "./generalPreferences.vue?vue&type=template&id=a3e8a3b4&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./generalPreferences.vue?vue&type=script&lang=js&"
export * from "./generalPreferences.vue?vue&type=script&lang=js&"
import style0 from "./generalPreferences.scss?vue&type=style&index=0&id=a3e8a3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e8a3b4",
  null
  
)

export default component.exports